import { Fragment, useEffect, useState } from 'react';
import { Headline, Link, List, Paragraph } from 'View/Common';
import { Image } from 'View/Common';
import { freddySad } from 'img/closing_popup';
import { StyledClosingPopup } from './ClosingPopup.styles';

const SESSION_KEY = 'closing_popup_dismissed';
const FAQ_URL = 'https://static.7schlaefer.app/eob/FAQs_7Schlafer_Einstellung.pdf';

export const ClosingPopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    try {
      if (typeof sessionStorage !== 'undefined') {
        if (!sessionStorage.getItem(SESSION_KEY)) {
          setIsOpen(true);
        }
      }
    } catch {
      /* SSR / Private Mode */
    }
  }, []);

  const handleClose = () => {
    try {
      if (typeof sessionStorage !== 'undefined') {
        sessionStorage.setItem(SESSION_KEY, 'true');
      }
    } catch {
      /* ignore */
    }
    setIsOpen(false);
  };

  return (
    <StyledClosingPopup isOpen={isOpen} toggle={handleClose}>
      <div className="modal-body">
        <Headline level={2}>7Schläfer wird eingestellt</Headline>
        <Paragraph>
          Wir bedanken uns für deine Treue und dafür, dass du die 7Schläfer-App mit deiner Nutzung zu dem gemacht hast, was sie heute ist.
        </Paragraph>
        <Paragraph className="bold">Was bedeutet das für dich?</Paragraph>
      </div>
      <div className="list-wrapper">
        <List>
          {[
            <Fragment key="item_1">Du kannst deinen Zugriff noch bis 30.09.2026 nutzen.</Fragment>,
            <Fragment key="item_2">Nach dem 30.09.2026 wird der Betrieb für Nutzende mit Abo oder Einmalzahlung eingestellt.</Fragment>,
            <Fragment key="item_3">
              Weitere Antworten auf deine Fragen findest du in diesem{' '}
              <Link href={FAQ_URL} title="FAQ als PDF herunterladen" target="_blank" rel="noopener noreferrer">
                FAQ
              </Link>
              .
            </Fragment>,
          ]}
        </List>
      </div>
      <div className="illustration-wrapper">
        <Image src={freddySad} alt="Trauriger Siebenschläfer" className="siebenschlaefer" />
      </div>
    </StyledClosingPopup>
  );
};
